function MainContentsLayout({ children }: { children: React.ReactNode }) {
  /**
   * レンダリング
   */
  return <main className="flex-1">{children}</main>;
}

export default MainContentsLayout;
